import clsx from 'clsx'
import first from 'lodash/first'
import reduce from 'lodash/reduce'
import React, { FC, useMemo } from 'react'

import { LinkTag, LinkTags } from '@Components/LinkTags'
import { Block, Link, Page } from '@Generated/graphql'
import { getJSONFieldValue, getMultipleLinkFieldValue } from '@Globals/CMS/FieldHelpers'

import styles from './TagsBlock.module.scss'

interface TagBlockData {
  caption: string
  tags: LinkTag[]
}

const getTagBlockData = (block: Block): TagBlockData => {
  const caption = getJSONFieldValue(block?.fields || [], 'caption')?.toString() || ''
  const links = getMultipleLinkFieldValue(block?.fields || [], 'links') || []
  const tags: LinkTag[] = reduce<Link, LinkTag[]>(links, (acc, link) => {
    const reference = first(link.references as Page[])
    const { id, title, type } = reference || {}
    if (title && link.url && id && type) {
      acc.push({
        id,
        newTab: !!link.newTab,
        link: link.url,
        name: title,
        type,
      })
    }
    return acc
  }, [])
  return { caption, tags }
}

interface TagBlockProps {
  id?: string
  tagBlock: Block
}

const TagBlock: FC<TagBlockProps> = ({
  id,
  tagBlock,
}) => {
  const { caption, tags } = useMemo(() => getTagBlockData(tagBlock), [tagBlock])
  return (
    <div className={clsx(styles.tagsBlock, 'tagsBlock')} id={id}>
      <LinkTags tags={tags} text={caption} />
    </div>
  )
}

export default TagBlock
